<!--
 * @Author: Shber
 * @Date: 2023-02-17 14:40:58
 * @LastEditors: Shber
 * @LastEditTime: 2023-02-22 16:28:13
 * @Description:
-->
<template>
  <div>
    <span v-wechat-title="$t('goods.title1')+'（'+dataCount+'）'" />
    <GCLOADING :is-show="isLoading" />
    <div class="goods_list">
      <List
        :loading="loading"
        :finished="finished"
        :finished-text="$t('bigEvent.info.text120')"
        @load="onLoad"
      >
        <div v-for="item in dataList" :key="item.id" class="list_item" @click="goPath(item)">
          <VanImage :src="item.firstpic" fit="cover" position="center" class="img" />
          <div class="goods_txt">
            <div>
              <h3 class="fw_bold text_overflow">{{ item.food_name }}</h3>
              <p class="text_overflow2">{{ item.jianjie1 }}</p>
            </div>
            <div class="txt"><span class="mr_5">{{ item.food_like }}人收藏</span> <span class="text_over">{{ item.nick_name }}</span></div>
          </div>
        </div>
      </List>
    </div>
  </div>
</template>
<script setup>
import '@/style/scss/goodsview/index.scss'
import config from '@/config/config'
import { ref } from 'vue'
import { useI18n } from 'vue-i18n/index'// 要在js中使用国际化
import { useRouter } from 'vue-router'
import { Image as VanImage, List, Toast } from 'vant'

import { get } from '@/api/ajax'
import { superLink, platformType } from '@/utils'
import GCLOADING from '@/components/gc-loading'

const { t } = useI18n() // 国际化方法
const router = useRouter()
const pathId = ref(router.currentRoute.value.query.id) // 页面id
const isLoading = ref(true) // 首页加载
const page = ref(0)
const dataList = ref([]) // 列表数据
const dataCount = ref(0) // 列表数量
const stopSign = ref(false)
const loading = ref(false) // 列表加载状态
const finished = ref(false) // 列表完成

const onLoad = (e) => {
  getDataList()
}

const getDataList = async() => {
  if (stopSign.value) { return false }
  stopSign.value = true
  page.value++
  const res = await get('/api/goods/feedback_food', { id: pathId.value, page: page.value })
  if (res.code === 1) {
    if (res.data.back_food.length === 0) {
      finished.value = true
      return Toast(t('bigEvent.info.text120'))
    }
    dataList.value = [...dataList.value, ...res.data.back_food]
    dataCount.value = res.data.back_food_count
  }
  isLoading.value = false
  stopSign.value = false
}
const goPath = (_item) => {
  // JSON标准格式双引号，eslint默认单引号，冲突
  sensors.track('GoodsViewFoodClick', {
    PlatformType: platformType(),
    goods_id: pathId.value,
    // goods_title: '',
    nickname: _item.nick_name,
    uid: _item.uid,
    food_id: _item.id,
    food_name: _item.food_name,
    position: '更多作品'
  })
  location.href = `${config.webapplink}/${_item.des}?id=${_item.id}`
  return false
  const data = `{
        "des": "${_des}", 
        "skuid": "${_skuid}",
        "link": "${config.webapplink}/${_des}?id=${_skuid}"
      }`
  return superLink(data)
}
</script>
